import { render, staticRenderFns } from "./GameHeader.vue?vue&type=template&id=5e801904&scoped=true"
import script from "./GameHeader.vue?vue&type=script&lang=js"
export * from "./GameHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e801904",
  null
  
)

export default component.exports